import { isSellableItemAvailable } from '../../selectors/items/is-sellable-item-available';
export const getAvailableItemProfilePages = (itemProfilePages) => {
    return itemProfilePages.reduce((acc, page) => {
        const availableButtons = getAvailableButtons(page.buttons);
        if (availableButtons.length)
            acc.push(Object.assign(Object.assign({}, page), { buttons: availableButtons }));
        return acc;
    }, []);
};
const getAvailableButtons = (itemButtons) => {
    return itemButtons.filter(itemButton => isSellableItemAvailable(itemButton));
};
